<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div class="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Artists</h5>
                            <div class="row text-center">
                                <div class="col">
                                    <label class="switch">
                                        <input v-model="addTab" type="checkbox" id="togBtn" @change="resetAlerts()">
                                        <div class="slider round">
                                            <span style="font-size: 15px;" class="off">Edit</span>
                                            <span style="font-size: 15px;" class="on">Add New</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="addTab == false">
                                <div class="row mb-5">
                                    <div class="col-3">
                                        <select class="form-control custom-dropdown" v-model="selectedArtist" @change="resetAlerts()">
                                            <option disabled selected value="">Pick an Artist</option>
                                            <option v-for="artist in artists" :key="artist.id" :value="artist">{{ artist.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectedArtist != ''">
                                    <div class="row mb-4">
                                        <div class="col-4">
                                            <label>Name:</label>
                                            <input v-model="selectedArtist.name" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col">
                                            <label class="form-check-label"><input type="checkbox" v-model="selectedArtist.BC"> BC</label>
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col">
                                            <label class="form-check-label"><input type="checkbox" v-model="selectedArtist.circa"> Circa</label>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-4">
                                            <div class="row">
                                                <div class="col-4">
                                                    <label>Year of Birth:</label>
                                                    <select style="padding: 10px;" class="form-control" v-model="selectedArtist.date_of_birth">
                                                        <option value="" selected disabled>Year</option>
                                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-4">
                                            <div class="row">
                                                <div class="col-4">
                                                    <label>Year of Death:</label>
                                                    <select style="padding: 10px;" class="form-control" v-model="selectedArtist.date_of_death">
                                                        <option value="" selected disabled>Year</option>
                                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div v-if="selectedArtist.image != null" class="col-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <p>{{ selectedArtist.image.split('/').pop() }}</p>
                                                </div>
                                                <div class="card-body">
                                                    <img :src="selectedArtist.image"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                                        :options="imageDropzoneOptions" 
                                                        :useCustomSlot=true 
                                                        v-on:vdropzone-sending="appendFileName" 
                                                        @vdropzone-file-added="fileInDropzone=true"
                                                        @vdropzone-removed-file="fileInDropzone=false">
                                                <div class="dropzone-custom-content">
                                                    <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                    <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg</div>
                                                </div>
                                            </Dropzone>
                                             <button class="btn btn-primary" @click="uploadImage">Upload Image</button>
                                            <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                        </div>
                                    </div>
                                </div>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                <button v-if="selectedArtist" class="btn btn-primary mt-5" @click="updateArtist()">Update</button>
                                <button v-if="selectedArtist" class="btn btn-primary btn-danger mt-5 float-right" @click="deleteArtist()"><i class="text-white fa fa-trash"></i> Delete Artist</button>
                            </div>

                            <div v-else>
                                <div class="row mb-4">
                                    <div class="col-4">
                                        <label>* Name:</label>
                                        <input v-model="newArtist" type="text" class="form-control"/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <label class="form-check-label"><input type="checkbox" v-model="newArtistBC"> BC</label>
                                    </div>
                                </div>
                                    <div class="row">
                                    <div class="col">
                                        <label class="form-check-label"><input type="checkbox" v-model="newArtistCirca"> Circa</label>
                                    </div>
                                </div>
                                
                                <div class="row mt-3">
                                        <div class="col-4">
                                            <div class="row">
                                                <div class="col-4">
                                                    <label>Year of Birth:</label>
                                                    <select style="padding: 10px;" class="form-control" v-model="newArtistBirth">
                                                        <option value="" selected disabled>Year</option>
                                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-4">
                                            <div class="row">
                                                <div class="col-4">
                                                    <label>Year of Death:</label>
                                                    <select style="padding: 10px;" class="form-control" v-model="newArtistDeath">
                                                        <option value="" selected disabled>Year</option>
                                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div v-if="allowImageUpload" class="col">
                                            <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                                        :options="imageDropzoneOptions" 
                                                        :useCustomSlot=true 
                                                        v-on:vdropzone-sending="appendFileName"
                                                        @vdropzone-file-added="fileInDropzone=true"
                                                        @vdropzone-removed-file="fileInDropzone=false">
                                                <div class="dropzone-custom-content">
                                                    <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                    <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg</div>
                                                </div>
                                            </Dropzone>
                                            <button class="btn btn-primary" @click="uploadImage">Upload Image</button>
                                            <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                        </div>
                                    </div>

                                <button class="btn btn-primary mt-5" @click="createNew()">Create Artist</button>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pending Artist Approvals -->
                <div class="row" v-if="isSuperAdmin">
                    <div class="card">

                        <div class="card-header">
                            <h5 class="card-title">Artists Pending Approval</h5>
                        </div>

                        <div class="card-body">
                            <v-client-table :data="artistsPendingApproval" :columns="artistsPendingColumns" :options="artistsPendingOptions">
                                <div slot="pendingActions" slot-scope="{row}">
                                    <button @click="approvePending(row)" class="transparent-button ml-3"><i class="edit-button fa fa-check"></i> Approve</button>
                                    <button @click="rejectPending(row)" class="transparent-button ml-3"><i class="delete-button fa fa-times"></i> Reject</button>
                                </div>
                            </v-client-table>
                        </div>

                    </div>
                </div>


            </div>
            <Footer />
        </div>

        <v-dialog />

    </div>
</template>

<script>
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import Artists from '../controllers/artist.controller';
import isSuperAdmin from "@/services/jwt/isSuperAdmin";

const imageUrl = process.env.VUE_APP_API_URL + '/image' || "http://localhost:3001/api/image";

export default {
    name: 'Artists',
    components: {
        Dropzone
    },
    data: function() {
        return {
            addTab: false,
            loading: false,
            allowImageUpload: false,
            artists: [],

            artistsPendingApproval: [],
            artistsPendingColumns: ['name', 'createdBy', 'created_at', 'pendingActions'],
            artistsPendingOptions: {
                perPage: 10,
                pagination: { chunk: 10, dropdown: false },
                filterable: false,
                headings: {
                    name: 'Name',
                    createdBy: 'Created By',
                    created_at: 'Created At',
                    pendingActions: 'Actions'
                },
                sortIcon: {
                    base : 'fa',
                    is: 'fa-sort',
                    up: 'fa-sort-asc',
                    down: 'fa-sort-desc'
                }
            },


            selectedArtist: '',
            newArtist: '',
            newArtistBirth: '',
            newArtistDeath: '',
            newArtistCirca: false,
            newArtistBC: false,
            errorMessage: '',
            successMessage: '',
            years: [], 
            imageDropzoneOptions: {
                url: (process.env.VUE_APP_API_URL + '/artist/upload/13') || "http://localhost:3001/api/artist/upload/13",
                maxFilesize: 50, // Mb
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: '.png,.jpg,.jpeg',
                header: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                }
            },
            fileInDropzone: false,
            isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin'))
        }
    },
    beforeMount: async function() {
        this.loading = true;

        for (let i = (new Date().getFullYear()); i > 0; i-- ) {
            this.years.push(i);
        }

        await this.loadArtists();
        this.loading = false;
    },
    methods: {
        async loadArtists() {

            this.artists = [];

            let pendingArtists = []

            let allArtist = await Artists.getAll();
            allArtist.forEach((artist) => {
                if (artist.approved === 1) {
                    this.artists.push(artist);
                }  else {

                    let createdAt = new Date(artist.created_at);
                    let day = createdAt.getDate() < 10 ? "0" + createdAt.getDate() : createdAt.getDate();
                    let month = (createdAt.getMonth() + 1) < 10 ? "0" + (createdAt.getMonth() + 1) : (createdAt.getMonth() + 1);
                    createdAt = month + "/" + day + "/" + createdAt.getFullYear();

                    pendingArtists.push({
                        id: artist.id,
                        name: artist.name,
                        createdBy: artist.createdBy !== null ? "@" + artist.createdBy.display_name : "N/A",
                        created_at: createdAt
                    });
                }
            });

            this.artistsPendingApproval = pendingArtists;
        },

        async approvePending(artist) {
            this.resetAlerts();

            let approved = await Artists.approve(artist.id);

            if (approved === false) {
                this.errorMessage = 'An error occurred approving the artist. Please try again.'
                this.successMessage = '';
            } else {
                this.errorMessage = ''
                this.successMessage = 'Artist successfully approved.';

                // Refresh the artist list
                await this.loadArtists();
            }
        },

        async rejectPending(artist) {

            this.$modal.show('dialog', {
                title: 'Reject Artist?',
                text: 'Rejecting the artist will permanently delete it from the system. Are you sure you want to delete the artist?',
                buttons: [
                    {
                        title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: 'DELETE',
                        class: 'vue-dialog-button vue-dialog-button-red',
                        handler: async () => {
                            this.$modal.hide('dialog');
                            await this._deleteArtist(artist.id);

                        }
                    }
                ]
            });

        },

        resetAlerts() {
            this.successMessage = '';
            this.errorMessage = '';
        },

        async createNew() {
            this.successMessage = '';
            this.errorMessage = '';

            if (!this.newArtist) {
                this.errorMessage = 'Please make sure all mandatory fields are filled';
                this.successMessage = '';
                return;
            }
            this.loading = true;

            let added = await Artists.createNew(this.newArtist, this.newArtistBirth, this.newArtistDeath, this.newArtistCirca, this.newArtistBC);

            if (added === false) {
                this.errorMessage = 'Something went wrong while creating your artist';
                this.successMessage = '';
            } else if (added.error) {
                this.errorMessage = added.error;
                this.successMessage = '';
            } else {
                this.errorMessage = '';
                this.successMessage = 'Artist created successfully';
                this.allowImageUpload = true;

                // Refresh the artist list
                await this.loadArtists();

                this.selectedArtist = this.artists.filter(item => item.id === added.id)[0];
            }

            this.loading = false;
        },

        async updateArtist() {
            this.successMessage = '';
            this.errorMessage = '';
            
            if (!this.selectedArtist.id) {
                this.errorMessage = 'Please pick a valid artist';
                this.successMessage = '';
                return;
            }
            this.loading = true;

            let updated = await Artists.update(this.selectedArtist.id, this.selectedArtist.name, this.selectedArtist.date_of_birth, this.selectedArtist.date_of_death, this.selectedArtist.circa, this.selectedArtist.BC);

            if (updated === false) {
                this.errorMessage = 'Something went wrong while updating your artist';
                this.successMessage = '';
            } else if (updated.error) {
                this.errorMessage = updated.error;
                this.successMessage = '';
            } else {
                this.errorMessage = '';
                this.successMessage = 'Artist updated successfully';
            }

            this.loading = false;
        },

        uploadImage() {
            this.$refs.imageDropzone.processQueue();
        },

        removeImage() {
            this.$refs.imageDropzone.removeAllFiles();
        },

        async appendFileName(file, xhr, formData) {
            file.upload.filename = Date.now() + Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);
            let uploaded = await Artists.uploadImage(this.selectedArtist.id, file.upload.filename, file.dataURL);
            if (uploaded === false) {
                this.errorMessage = "Something went wrong with uploading your image"
            } else if (uploaded.error) {
                this.errorMessage = uploaded.error;
            } else {
                this.successMessage = "Image uploaded successfully";
                this.selectedArtist = uploaded;
                this.$refs.imageDropzone.removeAllFiles();
            }
        },

        async deleteArtist() {
            if (!this.selectedArtist.id) {
                this.errorMessage = 'Please pick a valid artist';
                this.successMessage = '';
                return;
            }

            await this._deleteArtist(this.selectedArtist.id)
        },

        async _deleteArtist(id) {
            this.loading = true;

            let deleted = await Artists.delete(id);

            if (deleted === true) {
                this.errorMessage = '';
                this.successMessage = 'Artist deleted successfully';

                // Refresh the artist list
                await this.loadArtists();

                // Remove the artist info from the form
                this.selectedArtist = '';

            } else if (deleted.error) {
                this.errorMessage = deleted.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while deleting your artist';
                this.successMessage = '';
            }

            this.loading = false;
        }
    }
}
</script>